import templateUrl from 'emun.prospect/prospect-performance-rep.htm'
class ProspectPerformanceRepController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        $ctrl.prospects = [];

        $ctrl.salesreps = createAutoQuery({
            url: 'QuerySalesReps.json',
            orderBy: 'Name',
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function(reps) {
                reps.results.forEach(function(rep) {
                    $ctrl.prospects.push({
                        id: rep.id,
                        label: rep.name,
                        conversionRate: 0,
                        statusNew: 0,
                        statusOpen: 0,
                        statusConverted: 0
                    })
                });

                this.prospectQuery = createAutoQuery({
                    url: 'QueryProspects.json?dateRange=' + $ctrl.daterange + '&Count=Id&GroupBy=SalesRepID,Status',
                    autoLoad: true,
                    pageSize: 1000,
                    onLoaded: function(totals) {
                        totals.results.forEach(function(total) {
                            $ctrl.prospects.forEach(function(prospect) {
                                //console.info("BL*** evaluating " + JSON.stringify(total));
                                if (prospect.id == total.salesRepID) {
                                    if (total.status == 'Active') {
                                        prospect.statusOpen += total.Total;
                                    } else if (total.status == 'Converted') {
                                        prospect.statusConverted += total.Total;
                                    }
                                    prospect.statusNew += total.Total;
                                    prospect.conversionRate = Math.round((prospect.statusConverted / prospect.statusNew) * 100);
                                }
                            });
                        });
                    }
                });
            }
        });
    }
}

let ProspectPerformanceRep = {
    bindings: {
        daterange: '@'
    },
    controller: ProspectPerformanceRepController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}


export default ProspectPerformanceRep